import { ActionList, ActionListItem } from "@animech/ui";
import { FunctionComponent } from "react";
import { GlobeIcon, useUiData, MenuButton } from "src/ui";

export const MobileMenuPanel: FunctionComponent = () => {
	const {
		localizer,
		menu,
		visualization: {
			onToggleOpenDesignModal,
			onToggleSaveModal,
			onOpenLanguageModal,
		},
	} = useUiData();
	const { onRestart, onShare } = menu;

	return (
		<ActionList
			toggleElement={<MenuButton />}
			placement="bottom-start"
			transition="none"
		>
			<ActionListItem onClick={onOpenLanguageModal}>
				<span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
					<GlobeIcon size={20} />
					{localizer.localizeTerm("ui-buttons:globe")}
				</span>
			</ActionListItem>
			<ActionListItem icon="letter" onClick={onShare}>
				{localizer.localizeTerm("ui-buttons:email")}
			</ActionListItem>
			<ActionListItem icon="remove" onClick={onRestart}>
				{localizer.localizeTerm("restart")}
			</ActionListItem>
			<ActionListItem icon="load" onClick={() => onToggleOpenDesignModal(true)}>
				{localizer.localizeTerm("ui-buttons:open")}
			</ActionListItem>
			<ActionListItem icon="save" onClick={() => onToggleSaveModal(true)}>
				{localizer.localizeTerm("ui-buttons:save")}
			</ActionListItem>
		</ActionList>
	);
};
